import React, { useEffect, useState } from 'react'
import { UserOutlined,EyeInvisibleOutlined, EyeTwoTone, LockOutlined  } from '@ant-design/icons';
import { Input } from 'antd';
import image from '../../Assets/S3.jpg';
import AOS from "aos";
import "aos/dist/aos.css";
import './LoginPageCSS.css'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { generateDeviceSignature, getDeviceDetails, getUserIP, getUserLocation } from "./CommonLoginHeaders";
import axios from 'axios';
import { LoginApi } from '../AllAPI/CommonAPI/CommonApi';

const LoginPage = ({ onLogin }) => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  useEffect(() => { 
      // Clear session storage and refresh the page
      sessionStorage.clear();

    //---------------------------------Disabled back button-------------------------------
    window.history.pushState(null, null, window.location.href);

    const handleBackButton = (event) => {
      event.preventDefault();
      window.history.forward();
    };

    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, [navigate]);


  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');


  useEffect(() => {
    AOS.init({
      disable: "phone",
      duration: 700,
      easing: "ease-out-cubic",
    });
  }, []);

  //===========================================================

  // const handleLogin = async (e) => {
  //   e.preventDefault();

  //           const ip = await getUserIP();
  //           const location = await getUserLocation();

  //            // 🚨 Block login if location is 0,0 (Denied)
  //           //  if (location.lat === 0 && location.long === 0) {
  //           //      toast.error("Location access is required to login.");
  //           //     return; // Stop login process
  //           // }

  //           const deviceDetails = getDeviceDetails();
    
  //           const combinedData = {
  //               userIp: ip,
  //               userLat: location.lat,
  //               userLong: location.long,
  //               ...deviceDetails,
  //           };
    
  //           const deviceSign = generateDeviceSignature(combinedData);
    
  //           const headers = {
  //               userIp: ip,
  //               userLat: location.lat,
  //               userLong: location.long,
  //               deviceSign: deviceSign,
  //               deviceType: deviceDetails.deviceType,
  //               deviceOS: deviceDetails.deviceOS,
  //               browserName: deviceDetails.browserName,
  //               browserVersion: deviceDetails.browserVersion
  //           };


  
  //      if (username === 'admin' && password === '123') {  
      
  //            // ✅ Save headers and username in session storage
  //       sessionStorage.setItem('authHeaders', JSON.stringify(headers));
  //       sessionStorage.setItem('userData', username);
  //       sessionStorage.setItem('currentYear', new Date().getFullYear());
  
  //     onLogin();
  //     navigate('/dashboard');
  //   } else {
  //     toast.error('Invalid credentials');
  //   }
  // };
  


// const handleLogin = async (e) => {
//   e.preventDefault();

//   try {
//     const ip = await getUserIP();
//     const location = await getUserLocation();


//     const deviceDetails = getDeviceDetails();

//     const combinedData = {
//       userIp: ip,
//       userLat: location.lat,
//       userLong: location.long,
//       ...deviceDetails,
//     };

//     const deviceSign = generateDeviceSignature(combinedData);

//   const commonHeaders1 = {
//     headers: {
//       createdBy: 0,
//       updatedBy: 0,
//       userIp: ip,
//       userLat: location.lat,
//       userLong: location.long,
//       deviceSign: deviceSign,
//       deviceType: deviceDetails.deviceType,
//       deviceOS: deviceDetails.deviceOS,
//       browserName: deviceDetails.browserName,
//       browserVersion: deviceDetails.browserVersion,
//     },
//   }

//     const requestBody = {
//       loginId: username, // replace `username` with your state variable
//       password: password, // replace `password` with your state variable
//     };

//     const response = await axios.post(LoginApi,requestBody, commonHeaders1 );

//     if (response.data !== null) {
//       const token = response.data.token;
//       const userId = response.data.userId;
//       const user = response.data.user;
//       const sessionYear = response.data.sessionYear;
//       // Save session data
//       sessionStorage.setItem('authToken', token); // use this for future requests
//       sessionStorage.setItem('authHeaders', JSON.stringify(commonHeaders1));
//       sessionStorage.setItem('userId', userId);
//       sessionStorage.setItem('user', user);
//       sessionStorage.setItem('currentYear', sessionYear);

//       onLogin();
//       navigate('/dashboard');
//     } 
//   } catch (error) {
//     console.error('Login error:', error);
//     toast.error('An error occurred during login. Please try again.');
//   }
// };


const handleLogin = async (e) => {
  e.preventDefault();

  try {
    const ip = await getUserIP();
    const location = await getUserLocation();
    const deviceDetails = getDeviceDetails();

    const combinedData = {
      userIp: ip,
      userLat: location.lat,
      userLong: location.long,
      ...deviceDetails,
    };

    const deviceSign = generateDeviceSignature(combinedData);

    const commonHeaders1 = {
      headers: {
        createdBy: 0,
        updatedBy: 0,
        userIp: ip,
        userLat: location.lat,
        userLong: location.long,
        deviceSign: deviceSign,
        deviceType: deviceDetails.deviceType,
        deviceOS: deviceDetails.deviceOS,
        browserName: deviceDetails.browserName,
        browserVersion: deviceDetails.browserVersion,
      },
    };

    const requestBody = {
      loginId: username,
      password: password,
    };

    const response = await axios.post(LoginApi, requestBody, commonHeaders1);

    // Check if token, user, and userId exist
    const { token, userId, user, sessionYear } = response.data || {};

    if (token && user && userId) {
      // Save session data
      sessionStorage.setItem('authToken', token);
      sessionStorage.setItem('authHeaders', JSON.stringify(commonHeaders1));
      sessionStorage.setItem('userId', userId);
      sessionStorage.setItem('user', JSON.stringify(user));
      sessionStorage.setItem('currentYear', sessionYear);

      onLogin();
      navigate('/dashboard');
    } else {
      toast.error('Invalid credentials');
    }
  } catch (error) {
    console.error('Login error:', error);
    if (error.response && error.response.data && error.response.data.message) {
      toast.error(error.response.data.message); // API returns a message
    } else {
      toast.error('An error occurred during login. Please try again.');
    }
  }
};


  

  return (
    <>

        <div className="p-0 m-0">
        <div className="row loginPage p-0" >
           
           {/* ======== login page ========= */}
    
            <div className="container d-flex align-items-center justify-content-center" >
              <div className="row justify-content-center m-0 px-4">

                    <div className="row p-0 m-0">

                      <div className="col-12 col-lg-1 col-xs-12" ></div>

                      <div className="col-12 col-lg-10 col-xs-12" >

                      <div className="row p-0">
                        <h1>SANGLI ALUMINIUM EXTRUSIONS PVT. LTD.</h1>
                      </div>

                        <div className="row p-0 display" style={{border:"1px solid white"}}>

                              <div className="col-12 col-md-6 col-lg-8 col-sm-12 col-xs-12 display1" >
                                        {/* <img src={image} alt="image" style={{}}  /> */}
                              </div>

                              <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12" style={{backgroundColor:"#eaebf0",border:"1px solid white"}}>
                                <form onSubmit={handleLogin} className='loginForm' data-aos="fade-right">
                                <div className="row form-group px-2 py-5">
                                <h1 className="text-center pb-3">LOGIN HERE</h1>
                                  <div className="col-12">
                                      <label htmlFor="exampleInputEmail1">Email Id</label>
                                      <Input 
                                        type="text" className='py-2'
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        required
                                        placeholder="Enter Username" prefix={<UserOutlined />} />
                                  </div>
                                  <div className="col-12">
                                    <label htmlFor="exampleInputEmail1">Password</label>
                                      <Input.Password
                                        type="password" className='py-2'
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                        placeholder="Enter Password" prefix={<LockOutlined />}
                                        iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                      />
                                  </div>
                                  {/* <div className="col-12 text-end pt-1">
                                    <span className='forgotPass'  type='submit'>Forgot Password ?</span>
                                  </div> */}
                                  <div className="col-12 text-center pt-3">
                                    <button className='col-12 loginBtn'  type="submit">Login</button>
                                  </div>

                                  <div className="col-12 text-center pt-5 pb-0" style={{fontSize:"14px"}}>
                                    <span> &copy; {currentYear} Designed & Developed By TechnoAarv Solution</span>
                                </div>

                                </div>
                                </form>
                              </div>
                        </div>

                      </div>

                      <div className="col-12 col-lg-1 col-xs-12" ></div>

                  </div>
               
            </div>
            </div>
          
        </div>
        </div>

    </>
  )
}

export default LoginPage